// @ts-nocheck

import React, { useMemo } from 'react';
import styled from 'styled-components';

import Switch from '../../../components/common/Switch';
import { SwitchIconImg } from '../../../styled-components/shared';
import { type Licence } from '../../../types/common';
import { MPLogoImg } from '../assets/img';
import { MPSmallCardIconImgPaths, MPFamilies } from '../constants/families';
import { MPCardTypes } from '../types/cards';
import { MPFamilyIds, type MPFamilyId } from '../types/families';

const Wrapper = styled.div`
  display: flex;
  align-items: center;

  .switch-label {
    white-space: nowrap;
  }
`;

const MPBasketIconComponent = (props) => <SwitchIconImg {...props} src={MPLogoImg} />;

// eslint-disable-next-line react/display-name
const getMPCardBasketIconComponent = (iconPath) => (props) => <SwitchIconImg {...props} src={iconPath} />;

type Props = {
  className?: string;
  toggled: boolean;
  onToggle: (next: boolean) => void;
  disabled: boolean;
  licence: Licence;
  card: {
    familyId: MPFamilyId;
    index: number;
  };
};

const MPBasketSwitch = ({ className, toggled = false, onToggle, disabled, card, licence }: Props) => {
  const cardItem = useMemo(() => {
    let iconId = card.familyId;

    if (card.familyId === MPFamilyIds.ENERGY) {
      iconId = card.index === 1 ? MPCardTypes.ELECTRICITY : MPCardTypes.WATER;
    }

    return {
      icon: MPSmallCardIconImgPaths[iconId],
      name: MPFamilies[card.familyId][card.index - 1].name[licence],
    };
  }, [card.familyId, card.index, licence]);

  const SecondaryIcon = useMemo(() => getMPCardBasketIconComponent(cardItem.icon), [cardItem.icon]);

  return (
    <Wrapper className={className}>
      <Switch
        PrimaryIcon={MPBasketIconComponent}
        SecondaryIcon={SecondaryIcon}
        toggled={toggled}
        label={cardItem.name}
        onToggle={onToggle}
        disabled={disabled}
      />
    </Wrapper>
  );
};

export default MPBasketSwitch;
